(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("cornerstone", [], factory);
	else if(typeof exports === 'object')
		exports["cornerstone"] = factory();
	else
		root["cornerstone"] = factory();
})(self, function() {
return 